import { Box, Toolbar, Typography, AppBar, Button, CssBaseline, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import Sidebar from './Sidebar';
import React, { useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

const drawerWidth = 220;

interface AdminLayoutProps {
  onOpenChangePasswordModal: () => void;
  onOpenScanQRCodeModal: () => void;
}

function AdminLayout({ onOpenChangePasswordModal, onOpenScanQRCodeModal }: AdminLayoutProps) {
  const { signOut } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarOpen = () => setSidebarOpen(true);
  const handleSidebarClose = () => setSidebarOpen(false);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          {isMobile && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleSidebarOpen}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Shire Loyalty Admin
          </Typography>
        </Toolbar>
      </AppBar>
      <Sidebar
        open={isMobile ? sidebarOpen : true}
        onClose={handleSidebarClose}
        drawerWidth={drawerWidth}
        variant={isMobile ? 'temporary' : 'permanent'}
        onOpenChangePasswordModal={onOpenChangePasswordModal}
        onOpenScanQRCodeModal={onOpenScanQRCodeModal}
        onLogout={signOut}
      />
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}

export default AdminLayout;